import React, { useEffect, useRef } from "react";
import AnimateHeight from "react-animate-height";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export const DashboardSidebar = () => {
    const {contentsType}:any = useParams()
    const navigate = useNavigate()
    const location = useLocation()
    const path = location.pathname.split('/')

    return(
        <>
        <aside>
            <h2>
                <img src="/assets/images/hyundai_logo.png" alt="hyundai_logo"/>
            </h2>
            <ul className="mainMenu">
                <li className={path[2]==='prCenter'?'active prCenter' : 'prCenter'}>
                    <span onClick={()=>navigate('/dotsAdmin/prCenter/1')}>PR Center</span>
                    <AnimateHeight duration={500} height={path[2]==='prCenter'?'auto':0}>
                    <ul className="subMenu active">
                        <li className={contentsType === '1'?'active' : ''} onClick={()=>navigate('/dotsAdmin/prCenter/1')}>
                            <span>List of Announcement</span>
                        </li>
                        <li className={contentsType === '2'?'active' : ''} onClick={()=>navigate('/dotsAdmin/prCenter/2')}>
                            <span>List of Tech.Document</span>
                        </li>
                        <li className={contentsType === '3'?'active' : ''} onClick={()=>navigate('/dotsAdmin/prCenter/3')}>
                            <span>List of Catalogue</span>
                        </li>
                        <li className={contentsType === '4'?'active' : ''} onClick={()=>navigate('/dotsAdmin/prCenter/4')}>
                            <span>List of PR Video</span>
                        </li>
                    </ul>
                    </AnimateHeight>
                </li>
                <li className={path[2]==='customerCenter'?"active customerCenter":"customerCenter"}>
                    <span onClick={()=>navigate('/dotsAdmin/customerCenter/inquiry')}>Customer Center</span>
                    <AnimateHeight duration={500} height={path[2]==='customerCenter'?'auto':0}>
                    <ul className="subMenu active">
                        <li className={contentsType === 'inquiry'?'active':''} onClick={()=>navigate('/dotsAdmin/customerCenter/inquiry')}>
                            <span>List of Inquiry</span>
                        </li>
                        <li className={contentsType === 'faq'?'active':''} onClick={()=>navigate('/dotsAdmin/customerCenter/faq')}>
                            <span>List of FAQ</span>
                        </li>
                    </ul>
                    </AnimateHeight>
                </li>
                <li className={path[2]==='setting'?'active adminSetting':'adminSetting'}>
                    <span onClick={()=>navigate('/dotsAdmin/setting/adminStrator')}>Administrator Setting</span>
                    <AnimateHeight duration={500} height={path[2]==='setting'?'auto':0}>
                    <ul className="subMenu active">
                        <li className={contentsType === 'adminStrator'?'active':''} onClick={()=>navigate('/dotsAdmin/setting/adminStrator')}>
                            <span>List of Administrator</span>
                        </li>
                    </ul>
                    </AnimateHeight>
                </li>
            </ul>
        </aside>
        </>
    )
}